import React from 'react';
import ReactSelect from 'react-select';
import AsyncReactSelect from 'react-select/async';
import clsx from 'clsx';

import { GroupedOptionItem, OptionsItem } from 'utils/options';

import reactSelectStyles from './Select.styled';
import css from './Select.module.scss';

interface Props<TValue = string | number> {
    options?: Array<OptionsItem<TValue>> | Array<GroupedOptionItem<TValue>>;
    defaultOptions?: Array<OptionsItem<TValue>> | Array<GroupedOptionItem<TValue>> | boolean;
    placeholder?: string;
    isSearchable?: boolean;
    defaultValue?: OptionsItem;
    value?: any;
    onChange?: (option: OptionsItem) => void;
    onKeyDown?: (event: React.KeyboardEvent<HTMLElement>) => void;
    isAsync?: boolean;
    loadOptions?: ((input: string) => Promise<any>) | ((input: string, callback: Function) => void);
    cacheOptions?: boolean;
    isClearable?: boolean;
    onBlur?: Function;
    name?: string;
    onMenuClose?: (event: Event) => void;
    onMenuOpen?: (event: Event) => void;
    noOptionsMessage?: () => string;
    error?: boolean;
}

const Select: React.FC<Props> = (props) => {
    const Component = props.isAsync ? AsyncReactSelect : ReactSelect;

    return (
        <div className={clsx(css.select, props.error && css.error)}>
            {/* @ts-ignore wrong upstream types*/}
            <Component {...props} styles={reactSelectStyles} />
        </div>
    );
};

export default React.memo(Select);
